import { render, staticRenderFns } from "./OptionPanel.vue?vue&type=template&id=196f85af&scoped=true&"
import script from "./OptionPanel.vue?vue&type=script&lang=js&"
export * from "./OptionPanel.vue?vue&type=script&lang=js&"
import style0 from "./OptionPanel.vue?vue&type=style&index=0&id=196f85af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f85af",
  null
  
)

export default component.exports